import { GenericService } from '../../../../core/services/GenericService';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services';
import { ICartonConsumption } from '../../../cartons/core/interfaces/ICartonConsumption';

@Injectable({
  providedIn: 'root'
})
export class CartonConsumptionService extends GenericService<ICartonConsumption> {
  protected baseUrl = '/cartons/consumption';

  constructor(public apiService: ApiService) {
    super(apiService);
  }
}
